export default "__VITE_ASSET__DQNOkSmV__"